<template>
  <div class="content content-full">
    <div class="p-3 d-block d-sm-none">
      <button @click="getNewArtistUrl()" class="btn btn-block btn-gradient">
        <i class="fas fa-plus mr-1"></i>
        {{ $t('new_artist') }}
      </button>
    </div>
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100">
          <a class="nav-link" @click="tab = 'all'" href="javascript:void(0)" :class="{ active: tab === 'all' }">
            {{ $t('artists') }}
            <span class="count ml-1" v-if="artists.length">({{ artists.length }})</span>
          </a>
          <div class="ml-auto d-none d-sm-block">
            <button @click="getNewArtistUrl()" class="btn btn-gradient">
              <i class="fas fa-plus mr-1"></i>
              {{ $t('new_artist') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-inner">

      <!-- <div class="text-center mt-3 mb-3" v-if="!user.subscription">
        <ins class="adsbygoogle"
          style="display:block"
          data-ad-client="ca-pub-8326584585992829"
          data-ad-slot="3595200193"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div> -->

      <div class="p-5 text-center" v-if="loading">
        <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
      </div>

      <div class="row row-projects" v-if="!loading">
        <div class="col-sm-12 col-md-4 col-lg-3" v-for="item in artists" v-bind:key="item._id">
          <div class="card position-relative box make-it-slow">
            <div class="p-2">
              <a href="javascript:void(0)" @click="getArtistUrl(item)">
                <img class="card-img-top rounded" :src="item.cover_image_small || item.cover_image || defaultImage" :alt="item.name" onerror="this.src = '/static/img/img-placeholder-dark.jpg'">
              </a>
            </div>
            <div class="card-body pt-2">
              <a href="javascript:void(0)" @click="getArtistUrl(item)">
                <h4 class="mb-1 fw-bold">{{ item.name }}</h4>
              </a>
              <p class="text-muted small mb-0">{{ item.main_genre }}</p>
              <div class="mt-3">
                <a :href="`https://indiefy.me/${item.key}`" target="_blank" class="btn btn-gradient text-white btn-block">
                  <i class="fa fa-link mr-1"></i> {{ $t('website') }}
                </a>
                <div class="row mt-3">
                  <div class="col-6">
                    <button type="button" class="btn btn-default btn-block" @click="getArtistUrl(item)">
                      {{ $t('edit') }}
                    </button>
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-light btn-block" @click="getArtistReleases(item._id)" v-if="!user.freeze">
                      {{ $t('remove') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="modalConfirmDeleteArtist" class="modal modal-swal modal-h" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t('delete_artist_modal_title') }}
          </div>
          <div class="modal-body">
            <p class="text-center">
              <i class="fas fa-exclamation-triangle text-danger"></i>
              <span v-html="$t('delete_artist_modal_description_1')"></span>
            </p>
            <br>
            <p class="text-center">
              {{ $t('delete_artist_modal_description_2') }} <i>{{ deleteArtistPhrase }}</i>
              <input
                type="text" class="form-control border border-primary text-danger delete-confirm-phrase"
                @paste="$event.preventDefault()" v-on:keypress="validateOnlyLetter($event)"
                @drop="$event.preventDefault()" @dragenter.prevent @dragover.prevent
                v-model="deleteConfirmPhrase"
                :placeholder="deleteArtistPhrase"
                >
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-border no-border" data-dismiss="modal" @click="closeModalDeleteArtist()">{{ $t('cancel') }}</button>
            <button type="button" class="btn btn-danger" :disabled="deleteConfirmPhrase.toLocaleUpperCase() !== deleteArtistPhrase" @click="inactiveArtist(selectedArtistId)">{{ $t('delete') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div ref="modalDeleteArtistError" class="modal modal-swal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t('delete_artist_error_modal_title') }}
          </div>
          <div class="modal-body">
            <p class="text-center">
              {{ $t('delete_artist_error_modal_description') }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">{{ $t('i_understand') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Artists from '../services/artists'
import Distributions from '../services/distributions'
import _ from 'underscore'
import moment from 'moment'

export default {
  name: 'Artists',
  data () {
    return {
      tab: 'all',
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      loading: true,
      saving: false,
      artists: [],
      Distributions: [],
      processedDistros: 0,
      showDeleteArtistButton: false,
      deleteConfirmPhrase: '',
      deleteArtistPhrase: 'DELETE ARTIST',
      lang: 'en',
      selectedArtistId: '',
      moment: moment
    }
  },
  methods: {
    getArtistUrl: function (item) {
      if (this.user.freeze) {
        return this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      }
      this.$router.push(`/artists/${item.key}`)
    },
    getNewArtistUrl: function () {
      if (this.artists.length && (!this.user.subscription || this.user.subscription.plan_name === 'indiefy_lite')) {
        this.$router.push(`/upgrade?from=artist_page_limit_basic`)
      } else {
        this.$router.push(`/new-artist`)
      }
    },
    getArtists: function () {
      this.loading = true

      Artists.getAll().then(response => {
        this.artists = response.data
        this.loading = false

        if (!this.artists.length) {
          this.$router.push('/new-artist')
        }
      }).catch((err) => {
        console.error('Error whie trying to get all artists (artists page)', err)
      })
    },
    getArtistReleases: function (artistId) {
      if (this.user.freeze) {
        return this.$notify({ message: this.$t('freeze_user_message') }, 'warning', 'fa-exclamation')
      }
      Distributions.getAll({artist: artistId}).then(response => {
        this.distributions = response.data
        this.processedDistros = _.filter(
          this.distributions,
          // status 1 - In Review, status 2 - In Process, status 3 - Published and status 5 - takedown requested
          item => (item.status !== 1) && (item.status !== 2) && (item.status !== 3) && (item.status !== 5)
        ).length

        if (this.processedDistros) {
          this.selectedArtistId = artistId
          window.$(this.$refs.modalConfirmDeleteArtist).modal('show')
        } else {
          window.$(this.$refs.modalDeleteArtistError).modal('show')
        }
      }).catch(() => {
        console.error('Error while trying to get all releases (artists page)')
      })
    },
    closeModalDeleteArtist: function () {
      this.deleteConfirmPhrase = ''
      this.selectedArtistId = ''
    },
    inactiveArtist: function (artistId) {
      window.$(this.$refs.modalConfirmDeleteArtist).modal('hide')
      this.closeModalDeleteArtist()
      Artists.inactive(artistId).then(response => {
        this.$notify({ message: this.$t('artist_removed') }, 'success', 'fa-check')
        this.getArtists()
      }, err => {
        let error = err.response.data.name

        if (error === 'resolve_application_first') {
          this.$notify({ title: 'Oops', message: this.$t('resolve_application_first_delete') }, 'danger', 'fa-exclamation')
        }
      }).catch((error) => {
        console.error('Error while trying to remove artist', error)
      })
    },
    validateOnlyLetter: function (e) {
      let char = String.fromCharCode(e.keyCode)
      if (char.match(/^[A-Za-z]+$/) || e.keyCode === 32) {
        return true
      } else {
        e.preventDefault()
      }
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale
    this.getArtists()

    if (this.lang === 'es') {
      this.deleteArtistPhrase = 'BORRAR ARTISTA'
    }
  },
  mounted: function () {
    // if (!this.user.subscription) {
    //   setTimeout(() => {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }, 4000)
    // }
  }
}
</script>

<style scoped>
.space-filter {
  height: 72px;
}
.box {
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  transition: all 0.3s ease-in-out;
}
.box::after {
  content: '';
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  transition: opacity 0.3s ease-in-out;
}
.background-pro-guitar {
  background-image: url('/static/img/landing/pro/pro_background_guitar.jpg');
  background-size: cover;
  background-position: right;
}
.background-metadata {
  background-image: url('/static/img/landing/pro/metadata_background.jpg');
  background-size: cover;
  background-position: center;
}
.delete-confirm-phrase {
  margin: 0 auto;
  width: 50%;
  text-align: center;
  text-transform: uppercase;
  font-weight: 600;
}
.delete-confirm-phrase::placeholder {
  color: #FF0000;
  font-weight: normal;
}
.on-demand-options {
  min-width: 280px;
}
</style>



// WEBPACK FOOTER //
// src/components/Artists.vue